import { DASHBOARD_ROLES } from '../auth/roles'

/**
 * Single source of truth for every micro frontend the shell registers.
 *
 * `name` and `activeWhen` are application topology: they are identical in every
 * environment. Only the domain varies, and that lives in `microfrontend-env.json`, so an
 * app added here is correct in every environment by construction.
 */
export interface MicrofrontendRegistration {
  /** Import map key. Must match the name the micro app publishes itself under. */
  name: string
  /** Subdomain, combined with the environment domain to build the bundle url. */
  host: string
  /** Path prefix that activates this app. */
  activeWhen: string
  /**
   * Escape hatch for an app that is not hosted under the environment domain.
   * When set, `host` is ignored and this url is used verbatim in every
   * environment, so prefer `host` unless the app genuinely lives elsewhere.
   */
  url?: string
  /** Mounted only for users with at least one of these roles; omit for everyone. */
  roles?: string[]
}

export const MICROFRONTEND_REGISTRY: MicrofrontendRegistration[] = [
  {
    name: '@tccc/faq-microfrontend',
    host: 'pg3generalinformation',
    activeWhen: '/faq',
  },
  {
    name: '@tccc/ideas-bank',
    host: 'pg3ideasbank',
    activeWhen: '/ideas-bank',
  },
  {
    name: '@tccc/our_work',
    host: 'pg3ourwork',
    activeWhen: '/our-work',
  },
  {
    name: '@tccc/prioritization-process',
    host: 'pg3prioprocess',
    activeWhen: '/prioritization-process',
  },
  {
    name: '@tccc/innovation-process',
    host: 'pg3innovation',
    activeWhen: '/innovation-process',
  },
  {
    name: '@tccc/onboarding',
    host: 'pg3onboarding',
    activeWhen: '/onboarding',
  },
  {
    name: '@tccc/experience-loop',
    host: 'pg3exploop',
    activeWhen: '/experience-loop-process',
  },
  {
    name: '@tccc/persistent-platform',
    host: 'pg3masteroftaste',
    activeWhen: '/persistent-platform',
  },
  {
    name: '@tccc/tools-and-support',
    host: 'pg3toolsandsupport',
    activeWhen: '/tools-and-support',
  },
  {
    name: '@tccc/communities-of-practitioners',
    host: 'pg3cos',
    activeWhen: '/communities-of-practitioners',
  },
  {
    name: '@tccc/marketing-capabilities',
    host: 'pg3mtep',
    activeWhen: '/marketing-capabilities',
  },
  {
    name: '@tccc/dashboard',
    host: 'pg3exprofile',
    activeWhen: '/page-dashboard',
    roles: DASHBOARD_ROLES,
  },
  {
    name: '@tccc/experience-profile',
    host: 'pg3exprofile',
    activeWhen: '/experience-profile',
  },
  {
    name: '@tccc/nma-home',
    host: 'pg3nmalanding',
    activeWhen: '/nma-home',
  },
  {
    name: '@tccc/nma-gallery',
    host: 'pg3nmagalleryindex',
    activeWhen: '/nma-gallery',
  },
  {
    name: '@tccc/agency-roster',
    host: 'pg3agencyroster',
    activeWhen: '/agency-roster',
  },
]
